import React, { useEffect, useState } from "react";
import About_Us_1 from "../video/About_Us_1.mp4";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

function AboutUs() {
  const [hasVideoSection, setHasVideoSection] = useState(false);

  useEffect(() => {
    setHasVideoSection(
      !!document.querySelector(".dashboard-background .video-container")
    );
  }, []);

  return (
    <div>
      <div
        className="dashboard-background"
        style={{
          padding: hasVideoSection ? "0px" : "20px",
          overflow: "hidden",
        }}
      >
        <div className="video-container mb-4">
          <video
            autoPlay
            loop
            muted
            onLoadedMetadata={(e) => (e.target.playbackRate = 1)}
            className="full-width-video"
          >
            <source src={About_Us_1} type="video/mp4" />
          </video>
          <div className="video-overlay-text">
            <h1>"Our Story"</h1>
            <p className="hide-on-small">
              At Tarushi Healthcare, we are passionate about empowering
              healthcare organizations to deliver exceptional patient care. Our
              journey started with a simple mission: to help healthcare
              organizations improve their operations and provide better care for
              their patients.
            </p>
          </div>
        </div>

        <div className="information-section-about-us flex flex-column align-items-center text-center">
          <div>
            <p>
              We believe that every patient deserves the best care possible, and
              we are committed to empowering healthcare organizations to achieve
              this goal. Our team is made up of experienced business management
              consultants who have worked with healthcare organizations of all
              sizes.{" "}
              <span className="dashboard-imp">
                We understand the unique challenges facing healthcare
                organizations, and we have the expertise to help them overcome
                these challenges and achieve their goals.
              </span>
            </p>
          </div>
        </div>

        <div className="information-section-about-us flex flex-column align-items-center text-center">
          <div>
            <p>
              Whether you are a small clinic or a large hospital, we are here to
              help you succeed.
            </p>
          </div>
        </div>

        <div className="subscribe-section">
          <h2>Connect with us for more updates</h2>
          <form className="p-fluid subscribe-form">
            {/* Name Fields in a Single Row */}
            <div className="grid">
              <div className="col-6">
                <label htmlFor="first-name" className="block font-medium ">
                  First Name *
                </label>
                <InputText
                  id="first-name"
                  placeholder="Enter your first name"
                  required
                  className="w-full"
                />
              </div>
              <div className="col-6">
                <label htmlFor="last-name" className="block font-medium ">
                  Last Name *
                </label>
                <InputText
                  id="last-name"
                  placeholder="Enter your last name"
                  required
                  className="w-full"
                />
              </div>
            </div>

            {/* Email Field */}
            <div className="mt-1">
              <InputText
                id="email"
                type="email"
                placeholder="e.g., email@example.com"
                required
                className="w-full"
              />
            </div>

            {/* Message Field */}
            <div className="mt-3">
              <InputTextarea
                id="message"
                placeholder="Write your message here..."
                rows={4}
                className="w-full"
              />
            </div>

            {/* Submit Button */}
            <Button
              type="submit"
              label="Join Our Mailing List"
              className="mt-2 w-full"
            />
          </form>
          <p className="subscribe-note">Let's get in touch !!</p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
